import React, { useState } from "react";
import { Form } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { addSection } from "../../REDUX/actions/section";
import CustomButton from "../Common/CustomButton";
import { LAYOUT_LABELS } from "../sectioninput/SectionInput";
import "./SectionPanel.css";

// Default values matching how the website renders each article layout (see detectLayout).
const ARTICLE_PRESETS = {
  text: {
    title: "New section",
    subtitle: "Heading",
    description: "Write your text here",
  },
  textImage: {
    title: "New section",
    subtitle: "Heading",
    description: "Write your text here",
    name: "text-image",
  },
  highlight: {
    title: "5 days",
    subtitle: "5 days",
    description: "Short description",
  },
  quote: { title: "", subtitle: "", description: '<i>"Your quote here."</i>' },
  image: { title: "", subtitle: "", description: "", name: "image" },
  gallery: { title: "Gallery", subtitle: "", description: null, carousel: [] },
};

const SectionPanel = ({ eventItemForm, type = "articles", backRoute }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const backTo = () => {
    navigate(backRoute === "articles" ? "/blog" : "/events");
  };
  const [withImage, setwithImage] = useState(false);
  const [layout, setLayout] = useState("text");

  const sections = eventItemForm.attributes.sections.data;
  const allSectionIds = sections.map((el) => el.id);
  // The website only displays the first section titled "Gallery".
  const hasGallery = sections.some((el) => el.attributes.title === "Gallery");
  const nextOrder =
    Math.max(0, ...sections.map((el) => el.attributes.order || 0)) + 1;

  const addNewSection = () => {
    if (type === "articles") {
      if (layout === "gallery" && hasGallery) return;
      dispatch(
        addSection(type, eventItemForm.id, allSectionIds, false, {
          content: "",
          resolution: "Carré (800 * 800)",
          ...ARTICLE_PRESETS[layout],
        }, nextOrder)
      );
      if (layout === "gallery") setLayout("text");
    } else {
      dispatch(addSection(type, eventItemForm.id, allSectionIds, withImage));
    }
  };

  return (
    <div className="container-fluid bg-white rounded-10 p-5 shadowed">
      <h2 className="mb-0 f24 fw-normal text-start">Toolbox</h2>
      <div className="row mt-3">
        <div className="col-12">
          <CustomButton
            outlined
            buttonText={
              type === "articles"
                ? "Back to articles"
                : "Back to events"
            }
            iconStart="arrow-left"
            callBack={backTo}
          />
        </div>
        <div className="col-6">
          {/* <CustomButton outlined buttonText="Ajouter Section" iconStart="arrow-left" /> */}
        </div>
      </div>
      <div className="row addSection mt-3 bold f20" onClick={addNewSection}>
        Add a Section
      </div>
      {type === "articles" ? (
        <div className="row mt-3">
          <div className="col-12 text-start">
            <p className="mb-2">Section type</p>
            {Object.keys(ARTICLE_PRESETS).map((key) => (
              <Form.Check
                key={key}
                type="radio"
                name="section-layout"
                id={`section-layout-${key}`}
                label={key === "gallery" ? "With Gallery" : LAYOUT_LABELS[key]}
                checked={layout === key}
                disabled={key === "gallery" && hasGallery}
                onChange={() => setLayout(key)}
              />
            ))}
            {hasGallery && (
              <p className="f14 text-grey mt-2">
                This article already has a gallery: add or remove its images
                from the Gallery section.
              </p>
            )}
          </div>
        </div>
      ) : (
        <div className="row mt-3">
          <div className="col-12 text-center">
            <p>With Image</p>
            <Form.Check
              type="switch"
              color="primary"
              id="custom-switch"
              onChange={(e) => setwithImage(e.target.checked)}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default SectionPanel;
